import { createFileRoute } from '@tanstack/react-router';

import { HostContainer } from '@/features/hosts/containers/[host-id]';

export const Route = createFileRoute('/_layout/hosts/$hostId')({
  component: HostContainer,
});
